import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import React, { VFC } from 'react';

import routes from '@/config/routes';
import { DEFAULT_PROFILE_IMAGE_PATH } from '@/constants/images';
import styles from '@/containers/MarketplacePage/FilterSideBar/MasterSearchBar/MasterSearchBar.module.scss';
import MasterSearchSubsection from '@/containers/MarketplacePage/FilterSideBar/MasterSearchBar/MasterSearchSubsection';
import generateSquareImageURL from '@/utils/generateSquareImageURL';
import { convertImgixURL } from '@/utils/imgixUtils';
import HIDDEN_USER_IDS from '@/constants/hiddenUserIDs';

type Props = {
  searchResults: Record<string, Array<any>>;
  onMouseLeave: () => void;
  onMouseEnter: () => void;
};

const MasterSearchModal: VFC<Props> = ({
  searchResults,
  onMouseLeave,
  onMouseEnter,
}) => {
  const { t } = useTranslation();
  const hasCreations = searchResults.creations.length !== 0;
  const hasUsers = searchResults.users.length !== 0;
  const hasNoResult =
    searchResults.creations.length === 0 && searchResults.users.length === 0;

  if (hasUsers) {
    searchResults.users = searchResults.users.filter(
      (el) => !HIDDEN_USER_IDS.includes(el.userId)
    );
  }

  return (
    <div
      className={styles.masterSearchModal}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
    >
      {hasNoResult && <div>{t('filterSidebar.searchbar.noResult')}</div>}
      {hasCreations && (
        <MasterSearchSubsection title="NFT Names">
          {searchResults.creations.map((i, index) => (
            <Link
              key={`nft_${index}`}
              href={routes.creationDetail(i.creationID.toString())}
            >
              <a>
                <img
                  src={
                    i.imageUrl
                      ? generateSquareImageURL(convertImgixURL(i.imageUrl), 40)
                      : DEFAULT_PROFILE_IMAGE_PATH
                  }
                  className={styles.nftImg}
                />
                <span className={styles.searchResultText}>{i.name}</span>
              </a>
            </Link>
          ))}
        </MasterSearchSubsection>
      )}
      {hasUsers && (
        <MasterSearchSubsection title="Profile Names">
          {searchResults.users.map((i, index) => (
            <Link key={`profile_${index}`} href={routes.myPage(i.userId)}>
              <a>
                <img
                  src={
                    i.profilePicUrl
                      ? generateSquareImageURL(
                          convertImgixURL(i.profilePicUrl),
                          40
                        )
                      : DEFAULT_PROFILE_IMAGE_PATH
                  }
                  className={styles.profileImg}
                />
                <span className={styles.searchResultText}>{i.displayName}</span>
              </a>
            </Link>
          ))}
        </MasterSearchSubsection>
      )}
    </div>
  );
};

export default MasterSearchModal;
